var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    _vm._g(
      {
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          width: "40",
          height: "40"
        }
      },
      _vm.$listeners
    ),
    [
      _c("path", {
        staticStyle: {
          stroke: "none",
          "fill-rule": "nonzero",
          fill: "#4c00ff",
          "fill-opacity": "1"
        },
        attrs: {
          d:
            "M28.79 28.79v10.214a.97.97 0 0 1-.97.973H.97A.97.97 0 0 1 0 39.004V12.176c0-.535.434-.969.969-.969h10.195V27.82c0 .535.434.97.969.97Zm0 0"
        }
      }),
      _c("path", {
        staticStyle: {
          stroke: "none",
          "fill-rule": "nonzero",
          fill: "#ff5252",
          "fill-opacity": "1"
        },
        attrs: {
          d:
            "M39.973 14.387c0 8.582-5.012 14.383-11.184 14.402V17.977c0-.313-.125-.622-.348-.825l-5.617-5.613a1.142 1.142 0 0 0-.824-.351H11.184V.992c0-.539.437-.972.972-.972h15.13C34.464 0 39.972 5.777 39.972 14.387Zm0 0"
        }
      }),
      _c("path", {
        staticStyle: {
          stroke: "none",
          "fill-rule": "nonzero",
          fill: "#000",
          "fill-opacity": "1"
        },
        attrs: {
          d:
            "M28.441 17.133c.223.222.348.512.348.82V28.77H12.156a.972.972 0 0 1-.972-.97V11.188H22c.309 0 .621.122.824.352Zm0 0"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }